import { Section, TrilogyColor } from '@bytel/trilogy-react-ts';
import NavigationItem from '@shared/components/navigation-item';
import React from 'react';
import GroupePartenaire from './groupe-partenaire';
import useData from './hook';

const ListerPartenaires: React.FC = () => {
  const { partenaires, isFetching, isLoading, navigationItemConfig } = useData();

  return (
    <Section data-cy="pages-partenaires-container" skeleton={isFetching || isLoading} className="is-paddingless">
      <NavigationItem config={navigationItemConfig} />
      <Section background={TrilogyColor.WHITE}>
        <Section className="is-paddingless">
          {Object.keys(partenaires).map((group) => (
            <GroupePartenaire key={group} category={group} items={partenaires[group]} />
          ))}
        </Section>
      </Section>
    </Section>
  );
};

export default ListerPartenaires;
